<script>
export default {
  props: {
    farm: { type: Object, required: true },
    grazings: { type: Array, required: true },
  },

  data: () => ({
    selectedGrazing: undefined,
  }),

  watch: {
    selectedGrazing(to, from) {
      this.$emit('grazing-selected', to);
    },
  },
}
</script>

<template>
  <b-card>
    <b-list-group flush>

      <b-list-group-item
        v-for="grazing in grazings"
        :key="grazing.id"
        class="grazing-item"
        @click="selectedGrazing = selectedGrazing === grazing ? undefined : grazing">

        <div> {{grazing.camp_name}} </div>
        <div> {{grazing.created_date}} </div>

        <div v-if="selectedGrazing === grazing">
          <router-link :to="{name: 'grazing/single-grazing', params: { farmId: farm.id, grazingId: grazing.id }}" class="btn btn-primary btn-block mt-3">Open Camp</router-link>
        </div>

      </b-list-group-item>

    </b-list-group>
  </b-card>
</template>

<style scoped>
.grazing-item {
  cursor: pointer;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/grazing/components/GrazingsCard.vue